var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 26.296,
    viewBox: "0 0 37 26.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-users-4626688",
    transform: "translate(-105 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10081",
    "data-name": "Caminho 10081",
    d: "M507.3,325.5H504a10.2,10.2,0,0,1,.264,1.982v6.211a3.909,3.909,0,0,1-.264,1.321h5.55a1.421,1.421,0,0,0,1.321-1.321v-4.625A3.639,3.639,0,0,0,507.3,325.5Z",
    transform: "translate(-368.872 -203.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10082",
    "data-name": "Caminho 10082",
    d: "M445,181.507a4.627,4.627,0,1,0-4.625,4.757A4.8,4.8,0,0,0,445,181.507Z",
    transform: "translate(-305.775 -66.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10083",
    "data-name": "Caminho 10083",
    d: "M111.871,325.5h-3.3A3.553,3.553,0,0,0,105,329.068v4.625a1.421,1.421,0,0,0,1.321,1.321h5.418a3.281,3.281,0,0,1-.132-1.189v-6.211A3.767,3.767,0,0,1,111.871,325.5Z",
    transform: "translate(0 -203.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10084",
    "data-name": "Caminho 10084",
    d: "M149.25,181.507a4.627,4.627,0,1,0-4.625,4.757A4.8,4.8,0,0,0,149.25,181.507Z",
    transform: "translate(-32.357 -66.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10085",
    "data-name": "Caminho 10085",
    d: "M241.771,295.75h-9.911a4.4,4.4,0,0,0-4.361,4.361v6.211a1.248,1.248,0,0,0,1.321,1.321h15.857A1.248,1.248,0,0,0,246,306.321v-6.211A4.287,4.287,0,0,0,241.771,295.75Z",
    transform: "translate(-113.25 -176.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10086",
    "data-name": "Caminho 10086",
    d: "M277.064,116.893a5.948,5.948,0,1,0-5.814-5.946A5.811,5.811,0,0,0,277.064,116.893Z",
    transform: "translate(-153.696)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.0e03940a4d9035f8c6bd32f7cd026cba.svg";
export { ForwardRef as ReactComponent };